class StoreAvailabilityDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#StoreAvailabilityDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderDrawerIconAccessibility();
  }

  setHeaderDrawerIconAccessibility() {
    const self = this;

    $('.store-availability-drawer-opener').each(function() {
      const drawerLink = this;
      drawerLink.setAttribute('role', 'button');
      drawerLink.setAttribute('aria-haspopup', 'dialog');
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        self.open(drawerLink)
      });
      drawerLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          self.open(drawerLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const storeAvailabilityDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (storeAvailabilityDrawerNote && !storeAvailabilityDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(storeAvailabilityDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('StoreAvailabilityDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(storeAvailabilityDrawerNote) {
    storeAvailabilityDrawerNote.setAttribute('role', 'button');
    storeAvailabilityDrawerNote.setAttribute('aria-expanded', 'false');

    if(storeAvailabilityDrawerNote.nextElementSibling.getAttribute('id')) {
      storeAvailabilityDrawerNote.setAttribute('aria-controls', storeAvailabilityDrawerNote.nextElementSibling.id);
    }

    storeAvailabilityDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    storeAvailabilityDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('store-availability-drawer', StoreAvailabilityDrawer);
